import { render } from "./TerrariaVoyagerMod.vue?vue&type=template&id=5d091ac5&scoped=true"
import script from "./TerrariaVoyagerMod.vue?vue&type=script&lang=js"
export * from "./TerrariaVoyagerMod.vue?vue&type=script&lang=js"

import "./TerrariaVoyagerMod.vue?vue&type=style&index=0&id=5d091ac5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d091ac5"]])

export default __exports__